function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  "data-name": "TEU container",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M232.998 106.655l-67.725-56.008a25.974 25.974 0 00-16.29-35.952V0h-14.5v28.165h7.25a11.488 11.488 0 11-11.49 11.488h-14.5a25.91 25.91 0 002.227 10.537l-68.278 56.465h-28.42v162.992h240.944V106.655zM127.309 61.282a25.967 25.967 0 0028.395.267l54.542 45.106H72.444zm106.407 179.865H49.771V135.155h183.945z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M70.981 148.819h28.346v77.953H70.981zM184.304 148.684h28.346v77.953h-28.346zM127.559 148.819h28.346v77.953h-28.346z"
})));